<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <template v-slot:header>
            <b-row>
              <b-col md="6">
                <strong>Lista de Equipos</strong>
              </b-col>
              <b-col md="6" class="d-flex justify-content-end">
                <div v-if="loading" class="ml-2">
                  <b-spinner
                    variant="primary"
                    label="Spinning"
                    small
                  ></b-spinner>
                </div>
              </b-col>
            </b-row>
          </template>
          <div class="alert alert-success" v-if="isSuccess">
            Se registro correctamente
          </div>
          <form @submit.prevent="doPostEquipos">
            <div>
              <b-col>
                <b-input-group>
                  <div style="margin-right: auto">
                    <label class="m-0">
                      <strong class="text-black-50">Lista de equipos:</strong>
                    </label>
                    <select
                      v-model="listaEquipos"
                      class="form-control"
                      id="listaEquipos"
                    >
                      <option v-for="listEquips in NoDupes">
                        {{ listEquips.Lista }}
                      </option>
                    </select>
                  </div>
                  <div style="margin-right: auto">
                    <label class="m-0"
                      ><strong class="text-black-50">Buscar MP:</strong></label
                    >
                    <select
                      v-model="presupuesto"
                      class="form-control"
                      id="presupuesto"
                    >
                      <option v-for="mp in sortedMP">{{ mp.Numero }}</option>
                    </select>
                  </div>
                  <div style="margin-right: auto">
                    <label class="m-0">
                      <strong class="text-black-50"
                        >Buscar Nombre o Codigo:</strong
                      >
                    </label>
                    <b-input v-model="filter" type="search"></b-input>
                  </div>
                  <div style="margin-right: auto">
                    <!-- <br /><b-btn @click="addRow"
                      ><strong class="text-black-50"
                        >Guardar Cambios</strong
                      ></b-btn
                    > -->
                  </div>
                  <div style="margin-right: auto">
                    <br /><b-btn type="submit"
                      ><strong class="text-black-50"
                        >Registrar Productos</strong
                      ></b-btn
                    >
                  </div>
                </b-input-group>
              </b-col>
              <div v-if="!templist.length"></div>
              <div v-else>
                <div class="mt-5 tables">
                  <b-table
                    style="overflow-y: scroll"
                    striped
                    hover
                    :items="templist"
                    :fields="btnFields"
                    table-layout:
                    fixed
                  >
                    <template
                      :slot="btnRemove.key"
                      v-for="btnRemove in rmButton"
                      slot-scope="{ item }"
                    >
                      <b-btn
                        v-model="item[btnRemove.key]"
                        @click="removeRow(item.index)"
                      >
                        <strong class="text-black-50">X</strong>
                      </b-btn>
                    </template>
                  </b-table>
                  <template>
                    <!-- <p>{{ templist2 }}</p> -->
                  </template>
                </div>
              </div>
            </div>
          </form>
          <b-card-body class="table-responsive">
            <b-row class="justify-content-between">
              <!-- @row-clicked="onRowClicked" -->
              <b-table
                :items="filterlist"
                :current-page="currentPage"
                :per-page="perPage"
                :fields="EquipListTableFields"
                :busy="loading"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :tbody-tr-class="getTableClass"
                show-empty
                striped
                empty-filtered-text="No se encontró coincidencia"
                empty-text="No hay equipos disponibles"
                head-variant="light"
                sort-icon-left
                table-layout:
                fixed
              >
                <template v-slot:table-busy>
                  <div class="text-center text-info my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>
                <template
                  :slot="field.key"
                  v-for="field in editableFields"
                  slot-scope="{ item, value }"
                >
                  <b-input
                    v-model="item[field.key]"
                    type="number"
                    min="0"
                    @change="onRowClicked"
                    id="inputCantidad"
                  ></b-input>

                  <!-- oninput="this.value = Math.abs(this.value)"
                  </b-input> -->
                </template>

                <template
                  :slot="ChBox.key"
                  v-for="ChBox in box"
                  slot-scope="{ item }"
                >
                  <b-button
                    v-model="item[ChBox.key]"
                    v-on:click="[onRowClicked(item), addRow($event)]"
                    >Añadir</b-button
                  >
                </template>
              </b-table>
            </b-row>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              aria-controls="equips"
              align="center"
            ></b-pagination>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template> 

<script>
import GoBackComponent from "@/components/GoBackComponent";
import { mapActions, mapState } from "vuex";
import Vue from "vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import axios from "axios";
Vue.component("v-select", vSelect);

export default {
  name: "EquipmentList",
  components: {
    GoBackComponent,
  },
  data: function () {
    return {
      loading: false,
      isSuccess: false,
      templist: [],
      templist2: [],
      listaEquipos: {},
      PresupID: "",
      listEquips: [],
      equips: [],
      presup: [],
      user: '',
      mps: [],
      tmpIndex: 1,
      presupuesto: {},
      perPage: 20,
      currentPage: 1,
      EquipListTableFields: [
        { key: "codigo", sortable: true },
        { key: "Nombre", sortable: true },
        { key: "Cantidad", editable: true },
        { key: "ChkBox", label: "", box: true },
      ],
      btnFields: [
        { key: "MP", label: "MP" },
        { key: "codigo", label: "Codigo" },
        { key: "Nombre", label: "Nombre" },
        { key: "Cantidad", label: "Cantidad" },
        { key: "ButtonRemove", label: "", btnfieldtemptable: true },
      ],
      sortBy: "id",
      sortDesc: false,
      filter: "",
      templist: [],
      selecteditemList: null,
    };
  },
  mounted() {
    this.loading = true;
    this.user = JSON.parse(this.$store.getters.user);
    
    this.getListadoEquipos()
      .then((equips) => {
        this.equips = equips;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.loading = false;
      });

    this.getPresupuesto()
      .then((presup) => {
        this.presup = presup;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    ...mapActions([
      "getListadoEquipos",
      "getPresupuesto",
      "postCargaEquipos",
      "login",
    ]),

    cargaEquipos(evt) {
      evt.preventDefault();
      this.loading = true;
      this.cleanErrors();

      if (!this.postlist.length) {
        return;
      } else {
        this.$store
          .dispatch("postCargaEquipos", this.postlist)
          .then((response) => {
            this.isSuccess = true;
            this.cleanErrors();
            this.cleanForm();
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    cleanErrors() {
      this.errorMessage = "";
    },
    cleanForm() {
      this.templist = "";
    },

    changeitemList(event) {
      this.selecteditemList =
        event.target.options[event.target.options.selectedIndex].text;
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onRowClicked(item) {
      this.selectedRow = item;
    },
    addRow(item) {
      if (
        this.selectedRow.Cantidad !== null &&
        this.selectedRow.Cantidad > 0 &&
        this.presupuesto.length > 0
      ) {
        this.templist.push({
          MP: this.presupuesto,
          codigo: this.selectedRow.codigo,
          Nombre: this.selectedRow.Nombre,
          Cantidad: this.selectedRow.Cantidad,
          index: this.tmpIndex++,
        });

        for (let i = 0; i < this.presup.length; i++) {
          if (this.presup[i].Numero == this.presupuesto) {
            this.PresupID = this.presup[i].PresupuestosId;
          }
        }
        let uuid = self.crypto.randomUUID();

        this.templist2.push({
          EquipoId: this.selectedRow.productoId,
          ListaID: this.selectedRow.ListaID,
          MPid: this.PresupID,
          Cantidad: parseFloat(this.selectedRow.Cantidad).toFixed(10),
          Guid: uuid,
          Tecnico: this.user.firstName + ' ' + this.user.lastName,
          index: this.tmpIndex - 1,
        });
      }
    },

    removeRow(index) {
      this.templist = this.templist.filter((item) => item.index !== index);
      this.templist2 = this.templist2.filter((item) => item.index !== index);
    },

    doEdit(item) {
      this.$set(item, "temp", JSON.parse(JSON.stringify(item)));
      this.$set(item, "editing", true);
    },

    doSave(item) {
      this.$set(item, "editing", false);
      for (let key in item.temp) {
        if (item[key] != item.temp[key]) {
          item[key] = item.temp[key];
        }
      }
    },

    doCancel(item) {
      this.$set(item, "editing", false);
      this.$delete(item, "temp");
    },
    doPostEquipos() {
      for (let j = 0; j < this.templist2.length; j++) {
        let postlist = {
          EquipoId: this.templist2[j].EquipoId,
          ListaID: this.templist2[j].ListaID,
          MPid: this.templist2[j].MPid,
          Cantidad: this.templist2[j].Cantidad,
          Guid: this.templist2[j].Guid,
          Tecnico: this.templist2[j].Tecnico,
          index: this.templist2[j].index,
        };
        axios
          .post("https://portal.spctc.cr/SPCAPI/api/Carga_Equipos/", postlist)
          .then((response) => {
            this.isSuccess = true;
            setTimeout(() => {
              this.isSuccess = false;
            }, 5000);
            console.log(response);
          });
      }
    },
  },
  computed: {
    totalRows: function () {
      return this.equips.length;
    },
    sortedMP: function () {
      let SortMP = [
        ...new Map(this.presup.map((item) => [item.Number, item])).values(),
      ];
      function compare(a, b) {
        if (a.Number > b.Number) return -1;
        if (a.Number < b.Number) return 1;
        return 0;
      }
      return SortMP.sort(compare);
    },
    NoDupes() {
      let NoDupeList = [
        ...new Map(this.equips.map((item) => [item.Lista, item])).values(),
      ];
      function compare(a, b) {
        if (a.Lista < b.Lista) return -1;
        if (a.Lista > b.Lista) return 1;
        return 0;
      }
      return NoDupeList.sort(compare);
    },
    editableFields() {
      return this.EquipListTableFields.filter((field) => {
        return field.editable === true;
      });
    },
    box() {
      return this.EquipListTableFields.filter((field) => {
        return field.box === true;
      });
    },
    rmButton() {
      return this.btnFields.filter((field) => {
        return field.btnfieldtemptable === true;
      });
    },
    filterlist() {
      let equipos = this.equips;
      if (this.listaEquipos) {
        equipos = equipos.filter((eq) => eq.Lista.includes(this.listaEquipos));
      }
      return equipos;
    },
  },
};
</script>

<style>
.tables {
  height: 20vh;
  overflow-y: scroll;
}
.changes {
  background-color: blue;
}
</style>
